import * as Yup from 'yup';

export const validationSchema = Yup.object({
  emailValue: Yup.string()
    .matches(
      // eslint-disable-next-line
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      'Please enter a valid email',
    )
    .required('This field cannot be left blank')
    .trim(),
});
